import { ArrayUtils as NewArrayUtils } from '@colonist/utils';
(function(ArrayUtils) {
    function shuffle(array) {
        return NewArrayUtils.shuffle(array);
    }
    /**
     * @deprecated Import ArrayUtils from @colonist/utils
     */ ArrayUtils.shuffle = shuffle;
    function randomElementFromArray(array) {
        return NewArrayUtils.randomElementFromArray(array);
    }
    /**
     * @deprecated Import ArrayUtils from @colonist/utils
     */ ArrayUtils.randomElementFromArray = randomElementFromArray;
    function removeElementFromArray(array, element) {
        return NewArrayUtils.removeElementFromArray(array, element);
    }
    /**
     * @deprecated Import ArrayUtils from @colonist/utils
     */ ArrayUtils.removeElementFromArray = removeElementFromArray;
    function countOccurenceOfValueInArray(array, value) {
        return NewArrayUtils.countOccurenceOfValueInArray(array, value);
    }
    /**
     * @deprecated Import ArrayUtils from @colonist/utils
     */ ArrayUtils.countOccurenceOfValueInArray = countOccurenceOfValueInArray;
    function elementInArray(array, element) {
        return NewArrayUtils.elementInArray(array, element);
    }
    /**
     * @deprecated Import ArrayUtils from @colonist/utils
     */ ArrayUtils.elementInArray = elementInArray;
})(ArrayUtils || (ArrayUtils = {}));
export var ArrayUtils;
